import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RichTextEditor from 'react-rte';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';

import * as DASHBOARD_ACTIONS from 'hooks/useDashboard/actions';
import { getEmptyStringIfFalsy } from 'utils/string-helpers';

import StepControls from '../components/StepControls';

const useStyles = makeStyles({
  root: {
    flexGrow: 1
  },
  rootInput: {
    '& .MuiOutlinedInput-input': {
      padding: '15px 14px'
    }
  },
  rich_text_container: {
    minHeight: '250px',
    display: 'flex'
  },
  divider: {
    width: '100%',
    marginTop: '25px'
  },
  heading: {
    marginTop: '0px',
    marginBlockStart: '0px'
  }
});

const InformationStep = ({ setActiveStep, name, description, dispatchDashboard, isFirstStep }) => {
  const classes = useStyles();

  const [richTextValue, setRichTextValue] = useState(
    RichTextEditor.createValueFromString(getEmptyStringIfFalsy(description), 'html')
  );
  const [inputValue, setInputValue] = useState(name);
  const isValid = !!inputValue;

  const handleInputChange = event => {
    setInputValue(event.target.value);
  };
  const onRichTextChange = richTextValueTest => {
    setRichTextValue(richTextValueTest);
  };

  const handleBack = () => setActiveStep(prev => prev - 1);

  const handleNext = () => {
    setActiveStep(prev => prev + 1);

    dispatchDashboard({
      type: DASHBOARD_ACTIONS.UPDATED_DASHBOARD,
      payload: { name: inputValue, description: richTextValue.toString('html') }
    });
  };

  return (
    <>
      <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
        <Grid item xs={12}>
          <h3>Dashboard Name *</h3>
          <TextField
            onChange={handleInputChange}
            value={inputValue}
            name="name"
            label="Display name"
            variant="outlined"
            required
            fullWidth
            classes={{
              root: classes.rootInput
            }}
          />
        </Grid>
        <Box display="flex" mb={3} px={1} justifyContent="center" width="100%">
          <Divider className={classes.divider} />
        </Box>
        <Grid item container direction="column" xs={12}>
          <Grid item xs={12}>
            <h3 className={classes.heading}>Description *</h3>
          </Grid>
          <Grid item xs={12} className={classes.rich_text_container}>
            <RichTextEditor value={richTextValue} onChange={onRichTextChange} />
          </Grid>
        </Grid>
      </Grid>
      <StepControls
        isFirstStep={isFirstStep}
        isNextDisabled={!isValid}
        handleBack={handleBack}
        handleNext={handleNext}
      />
    </>
  );
};

InformationStep.propTypes = {
  description: PropTypes.string,
  name: PropTypes.string,
  setActiveStep: PropTypes.func.isRequired,
  dispatchDashboard: PropTypes.func.isRequired,
  isFirstStep: PropTypes.bool.isRequired
};

InformationStep.defaultProps = {
  description: '',
  name: ''
};

export default InformationStep;
